<template>

  <div >
    <ul >
      <li>
        <p>Название реестра</p>
        <p>Доступно к обзвону</p>
        <p>Всего в работе</p>
      </li>
      <li v-for="stat in statusCounter">
        <p>{{stat.WTF}}</p>
        <p>{{stat.EnabledCalls}}</p>
        <p>{{stat.MarketSourceCNT}}</p>
        <p></p>
      </li>
    </ul>
    <p style="text-align: left">Обновлено в {{timeUpdate}}</p>



  </div>
</template>

<script>
  export default {
    name: "counterOutgoing",
    data: function () {
      return {
        statusCounter: [],
        showLead:false,
        timeUpdate:''
      }
    },
    methods: {
      getStats() {
        let self = this;

        setTimeout(()=>{
          self.$myApi.SendRequest({'action':'Operator_getStatsCalls'}, self, 'counterOutgoing', false)
          .then((res)=>{
            self.statusCounter = res;
            let timeUpdate = new Date();
            self.timeUpdate = timeUpdate.getHours() + ':' + timeUpdate.getMinutes() + ':' +timeUpdate.getSeconds();
          }).catch((res)=>{console.log(res)});
        }, 60000);


      },
      formatArr(){

      }
    },
    mounted() {
      this.getStats();


    }
  }
</script>

<style scoped>
  ul{margin: 0;padding: 0;list-style: none;width: 500px;}
  ul li{display: flex;align-items: center;justify-content: flex-start;list-style: inherit;padding: 5px 0;}
  ul li:first-child{background: rgba(45, 130, 103, 0.32)}
  ul li p:nth-child(1){width: 300px;}
  ul li p:nth-child(2){width: 100px}
  ul li p:nth-child(3){width: 100px}
</style>
